
import '../jquery-type-polyfill';
import * as $ from 'jquery';
import 'slick-carousel';

export const initSlickCarousels = (className) => {
  /**
   *
   * Search all sliders on page and add ids
   *
   */
  let carousels = {};
  let allSliders = 0;

  carousels = document.querySelectorAll(`.${className}`);
  for(let i = 0; i < carousels.length; i++) {
    carousels[i].setAttribute(`id`, `${className}-${i}`)
    allSliders++
  }

  /**
   *
   * Add ids to controls them slidersand then init slick
   *
   */
  let carousel = {}
  let initContainer = {}
  let carouselConfig = {}
  let controlsContainer = {}
  let prevBtnId = ''
  let nextBtnId = ''
  let dotsBtnsId = 'string'

  for(let i = 0; i < allSliders; i++) {
    carousel = document.getElementById(`${className}-${i}`);

    //console.log(carousel.querySelector(`.carousel-controls`))
    //console.log(`${className}-${i}`)
    controlsContainer = carousel.querySelector(`.carousel-controls`).children
    prevBtnId = `${className}-prev-${i}`
    nextBtnId = `${className}-next-${i}`
    dotsBtnsId = `${className}-dots-${i}`
    /**
     *
     * Add custom id to controls buttons
     *
     */
    for(let x = 0; x < controlsContainer.length; x++) {
      if(controlsContainer[x].classList.contains(`${className}-prev`))
        controlsContainer[x].setAttribute(`id`, prevBtnId)
      else if (controlsContainer[x].classList.contains(`${className}-next`))
        controlsContainer[x].setAttribute(`id`, nextBtnId)
      else if (controlsContainer[x].classList.contains(`${className}-dots`))
        controlsContainer[x].setAttribute(`id`, dotsBtnsId)
    }

    /**
     *
     * Init slick
     *
     */
    initContainer = carousel.querySelector(`.carousel-init`)
    carouselConfig = carousel.dataset.config
    if(carouselConfig !== undefined) {
      /**
       * Config from DOM data set
       */
      carouselConfig = JSON.parse(carouselConfig)
    } else {
      /**
       * Default options
       */
      carouselConfig = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        infinite: false,
        arrows: false,
        dots: true,
      }
    }

    $(initContainer).slick({
      ...carouselConfig,
      appendDots: $(`#${dotsBtnsId}`),
      prevArrow: $(`#${prevBtnId}`),
      nextArrow: $(`#${nextBtnId}`),
    })

  }
}
